export interface IVulnerability {
  title: string;
  description: string;
  minScore: number;
  maxScore: number;
  css: string;
}
